// contactBarData.js

const contactBarData = {
    message: "Shape the New Era of Business with Imaggar Technologies",
    buttonLink: "/contact",
    buttonText: "Contact Us",
  };
  
  export default contactBarData;
  